import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { CrmCommentEntityType } from '@service-storage/generated/schemas/crmCommentEntityType';

export const crmKeys = createQueryKeys('crm', {
  lists: null,
  company: (companyId: string) => [companyId],
  contact: (contactId: string) => [contactId],
  contactByEmail: (teamId: string, email: string) => [teamId, email],
  comments: (entityType: CrmCommentEntityType, entityId: string) => [
    entityType,
    entityId,
  ],
});
